module.exports = __webpack_public_path__ + "img/32dc4c9.png";